export const READER_WITH_LOCATION = `/books/:vbid/:location*`;
export const DEV = "/dev";
export const DEV_FEATURES = "/features";
export const ERROR_BASE = "/error";
export const ERROR_SYSTEM = `${ERROR_BASE}/system`;
export const ERROR_NOT_FOUND = `${ERROR_BASE}/not-found`;
export const EMBED_WITH_PATH = "/embed/:path*";
export const CRANE_EMBED = "/crane/:vbid/:path*";
export const ENRICHMENT_STANDALONE = "/enrichment/:vbid/:id";
export const ENRICHMENT_PROGRESS = "/enrichment-progress/:vbid";
export const FLASHCARD_DECK = "/flashcards/deck/:deckId";
export const TEST = "/test/:type";
